import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    icon: {
      fontSize: '20px',
    },
    typography: {
      color: 'inherit',
      display: 'flex',
      marginBottom: unit / 2,
      maxWidth: '200px',
    },
  });

export default styles;
